import React from "react";
import { Box } from "@mui/material";
import { motion } from "framer-motion";

const FloatingElement = ({ 
  children, 
  delay = 0, 
  duration = 3,
  yOffset = 20,
  xOffset = 0,
  rotateAmount = 0,
  sx = {} 
}) => {
  return (
    <Box
      component={motion.div}
      animate={{
        y: [0, -yOffset, 0],
        x: xOffset ? [0, xOffset, 0] : 0,
        rotate: rotateAmount ? [0, rotateAmount, 0] : 0,
      }}
      transition={{
        duration: duration,
        repeat: Infinity,
        ease: "easeInOut",
        delay: delay,
      }}
      sx={sx}
    >
      {children}
    </Box>
  );
};

export default FloatingElement;